<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id || index" :row-index="index + 1">
      <van-row class="detail-row">
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>成本分析方案：</span>
        <span>{{ item.schemeTitle }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>基本单位：</span>
        <span>{{ item.meins | dictFilter(bstmeOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>供货品类：</span>
        <span>{{ item.catgName }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>税率(%)：</span>
        <span>{{ item.taxRate }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>价格失效周期规则：</span>
        <span>{{ item.expireRuleName }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>含税单价：</span>
        <span>{{ item.taxPriceAmount }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>阶梯报价：</span>
        <span>{{ item.priceStepModeDict | dictFilter(stepPriceOptions) }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>成本：</span>
        <span>{{ item.costAmount }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>税费：</span>
        <span>{{ item.taxAmount }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>利润：</span>
        <span>{{ item.profitAmount }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>利润率(%)：</span>
        <span>{{ item.profitRate }}</span>
      </van-row>
      <van-row class="detail-row">
        <span>价格浮动方式：</span>
        <span>{{ item.priceFloatingMethodDict | dictFilter(priceFloatingMethodOptions) }}</span>
      </van-row>
      <van-row v-if="shouldShowTaxPriceRange(item)" class="detail-row">
        <span>下限含税单价：</span>
        <span>{{ item.lowerTaxPrice }}</span>
      </van-row>
      <van-row v-if="shouldShowTaxPriceRange(item)" class="detail-row">
        <span>上限含税单价：</span>
        <span>{{ item.upperTaxPrice }}</span>
      </van-row>
      <van-row class="detail-action-row" gutter="8" type="flex" justify="start">
        <van-col v-if="item.priceStepModeDict && item.priceStepModeDict !== '0'" span="8">
          <van-button class="detail-action-btn" type="info" size="normal" @click="openStepPrice(item)"
            >查看阶梯价</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button class="detail-action-btn" type="info" size="normal" @click="openCompose(item)"
            >查看成本构成</van-button
          >
        </van-col>
      </van-row>
    </hi-card>
    <step-price-dialog
      :details-visible="stepPriceVisible"
      :line-id="currentLineId"
      @close-details-dialog="stepPriceVisible = false"
    />
    <compose-dialog
      :details-visible="composeVisible"
      :line-id="currentLineId"
      @close-details-dialog="composeVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: 'ChangePriceModeDetailList',
  components: {
    'step-price-dialog': () => import('./StepPriceDialog.vue'),
    'compose-dialog': () => import('./CostComposeDialog.vue')
  },
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      stepPriceVisible: false,
      composeVisible: false,
      currentLineId: undefined
    }
  },
  computed: {
    bstmeOptions() {
      return this.$store.getters.dicts.bstme
    },
    stepPriceOptions() {
      return this.$store.getters.dicts.tiered_price
    },
    // 价格浮动方式字典
    priceFloatingMethodOptions() {
      return this.$store.getters.dicts.price_floating_method
    }
  },
  methods: {
    // 当价格浮动方式为“2”时隐藏上下限含税单价
    shouldShowTaxPriceRange(item) {
      return String(item.priceFloatingMethodDict) !== '2'
    },
    openStepPrice(item) {
      this.currentLineId = item.id
      this.stepPriceVisible = true
    },
    openCompose(item) {
      this.currentLineId = item.id
      this.composeVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-action-row {
  margin-top: 6px;
}
.detail-action-btn {
  width: 100%;
  border-radius: 5px;
  font-size: 15px;
  height: 37px;
  padding-left: 1px;
  padding-right: 1px;
}
.detail-row span:first-child {
  color: #666666;
}
.detail-row span:last-child {
  color: #262626;
}
</style>
